import { post } from "@insite/client-framework/Services/ApiService";

export interface UpdateDateParams {
    deliveryDate: string;
}

const url = "/api/v2/Cart/UpdateCartLinesDate";

export const updateCartLineDate = async (parameters: UpdateDateParams) => {
    const response = await post<UpdateDateParams>(url, parameters);
    return response;
};
